<template>
  <v-row
    ><v-icon v-if="itemData.isExtra" color="yellow darken-2" left
      >mdi-star</v-icon
    >{{ itemData.boardBasis }}
  </v-row>
</template>

<script>
export default {
  name: "basis-label",

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/BasisLabel.vue